import React from 'react';
import { useLottie } from "lottie-react";

function LottieAnimation(props) {
    const {  animateFile } = props;
    const options = {
        animationData: animateFile,
        loop: true
    };
    const { View } = useLottie(options);
    return (
        <>
            {View}
        </>
       

    );
}

export default LottieAnimation;